import AjaxHelper from './AjaxHelper';

class TranslationHelper {
	constructor() {
		if (!TranslationHelper.instance) {
			this.translations = null;
			TranslationHelper.instance = this;
		}

		return TranslationHelper.instance;
	}

	async loadTranslations() {
		const temp = translationInstance.translations;// sessionStorage.getItem('translations');
		const loadedTranslations = (temp) ? JSON.parse(temp) : null;
		if (!loadedTranslations) {
			try {
				let language = ((navigator.languages && navigator.languages[0]) || navigator.language || 'en').toLocaleLowerCase().split(/[-_]/)[0];
				const languageSupport = ['en', 'it', 'es', 'jp', 'ru', 'de'];
				if (language === 'ja') {
					language = 'jp';
				}
				if (!languageSupport.includes(language)) {
					language = 'en';
				}
				// console.log('loading language file ---- ',language);
				const data = await AjaxHelper.invokeServerAPIPromise('/api/translation/getFile', { fileName: language });
				sessionStorage.setItem('language', language);
				translationInstance.translations = data.developerFile;
			} catch (e) {
				console.log('error getting translation file', e);
			}
		}
	}

	getValue(key) {
		if (this.translations) {
			return this.translations[key];
		} return key;
	}
}

const translationInstance = new TranslationHelper();
// Object.freeze(translationInstance);

export default translationInstance;
